import React from "react";
import "../Complexes/ResidentialComplexList.css";
import BuildingRow from "./BuildingRow";
import EmptyState from "../EmptyState";

export default function BuildingList({
  items = [],
  loading = false,
  onItemClick,
  flashIds,
  onEdited,
  emptyActionLabel,
  onEmptyAction,
  settlement = false,
}) {
  if (loading) {
    return (
      <div className={`rc-building-list ${settlement ? "rc-settlement-house-grid" : ""}`}>
        {[...Array(5)].map((_, i) => (
          <div key={i} className="rc-building-row rc-building-row--skeleton" />
        ))}
      </div>
    );
  }
  if (!items.length) {
    return (
      <EmptyState
        icon="building"
        title="Домов пока нет"
        subtitle="Добавьте первый дом"
        actionLabel={emptyActionLabel || "Добавить дом"}
        onAction={onEmptyAction}
      />
    );
  }
  return (
    <div className={`rc-building-list ${settlement ? "rc-settlement-house-grid" : ""}`}>
      {items.map((b) => (
        <BuildingRow
          key={b.id}
          id={b.id}
          name={b.name}
          address={b.address}
          counters={b.counters}
          incidents={b.incidents}
          manualSubmissionEnabled={b.manualSubmissionEnabled}
          onClick={onItemClick ? () => onItemClick(b.id) : undefined}
          isNew={!!flashIds?.has?.(b.id)}
          onEdited={onEdited}
          settlement={settlement}
        />
      ))}
    </div>
  );
}
